import * as React from 'react';
import {styled} from '../../utils';
import Card, {CardHeader, CardBody} from '../../components/Card';

const Heading = styled('h2')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 26,
  fontWeight: 300,
  color: '#7C4EF6',
  marginBottom: 42
}));

const SignedUpNotice = styled('p')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 16,
  fontWeight: 300,
  marginBottom: 42
}));

interface WelcomeState {
  chatOpen: boolean;
}

export default class Welcome extends React.Component<{}, WelcomeState> {
  constructor(props: {}) {
    super(props);
    this.state = {chatOpen: false};
  }

  public render() {
    return (
      <React.Fragment>
        <Card style={{marginTop: 20}}>
          <CardHeader>Welcome</CardHeader>
          <CardBody>
            <div style={{textAlign: 'center'}}>
              <Heading>Congratulations!</Heading>
              <SignedUpNotice>
                You have been logged in. You can control anything :).
              </SignedUpNotice>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Welcome/Welcome.tsx